export default "__VITE_ASSET__BnlDIqX1__"